import React from "react";
import Image from "next/image";

const MobBridgeUni: React.FC = () => {
  return (
    <>
      <div className="bg-white w-full">
        <div className="bg-[url(/images/ban.png)] px-5 py-8 text-white relative bg-cover bg-center bg-repeat md:py-[50px] md:bg-bottom">
          <div className="mx-auto h-full relative">
            {/* Mobile View */}
            <div className="text-center">
              <h2 className="text-2xl mb-3 leading-[1.8rem] text-black font-semibold text-center inline-block mx-auto px-[4px]">
                <span className="md:pb-0 inline-block border-[#ca7216] md:border-b-[4px] border-b-2">
                  About Jain University
                </span>
              </h2>
            </div>
            <div className="flex flex-col md:flex-row gap-4 justify-center md:mt-6">
              {/* Image Section */}
              <div className="rounded-md mb-4 md:mb-0">
                <div className="w-full md:w-[575px]">
                  <Image
                    src="/cpa/bridge-course/uniJain.svg"
                    alt="jain uni"
                    className="w-full"
                    width={328}
                    height={188.243}
                    priority
                  />
                </div>
              </div>

              {/* Text Section */}
              <div className="text-center">
                <p className="text-black font-medium text-[14px]">
                  For over 30 years, Jain University has been at the
                  <br /> forefront of delivering quality education, combining
                  <br />
                  academic excellence with real-world relevance.
                  <br /> Accredited and globally recognized, Jain University
                  <br />
                  offers CPA-integrated master's programs that
                  <br /> equip students with comprehensive accounting
                  <br /> knowledge and international credentials. With
                  <br /> flexible learning options, this program prepares
                  <br />
                  future-ready professionals for global opportunities
                  <br /> in finance and accounting.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobBridgeUni;
